import { entity } from "./Connection"

// Status has no per-day endpoint of its own: its rows ride the Log bundle
// (`logs.list` returns statuses alongside logs), so a Status query delegates to
// Log's fetch via `providedBy`. Live token (`Subscription.Status`), owner-FK
// indexes and the `deletedAt` soft-delete are auto-derived by `entity()`.
export const StatusEntity = entity("Status", { providedBy: "Log" });
